import SettingsTabBarContainer from './SettingsTabBarContainer';

export default SettingsTabBarContainer;
